module.exports = __webpack_public_path__ + "img/mexican_logo.e210c5d7.svg";